import { motion } from "framer-motion";

const slideVariants = {
  visible: {
    x: 0,
    opacity: 1,
    transition: {
      x: { type: "spring", stiffness: 300, damping: 30 },
      opacity: { duration: 0.2 },
    },
    height: "auto",
  },
  exit: (direction: number) => ({
    x: direction > 0 ? 100 : -100,
    opacity: 0,
    transition: {
      x: { type: "spring", stiffness: 300, damping: 30 },
      opacity: { duration: 0.2 },
    },
    height: 0,
  }),
  hidden: {
    x: 0,
    opacity: 0,
    height: 0,
  },
};

const Slider = ({
  animate,
  custom,
  children,
}: {
  animate: string;
  custom: any;
  children: React.ReactNode;
}) => {
  return (
    <motion.div
      key="email"
      initial="hidden"
      animate={animate}
      exit="exit"
      variants={slideVariants}
      custom={custom}
    >
      {children}
    </motion.div>
  );
};

export default Slider;
